import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useFormikContext } from "formik";
import PropTypes from "prop-types";
import { classNames } from "../../../utils/helpers";
import Icon from "../../Icon";
const Template = (props) => {
  const { onChange, value } = props;
  const { values } = useFormikContext();
  const { fieldsInfo } = values;
  return (
    <Dropdown>
      <Dropdown.Toggle size="sm" variant="secondary">
        Campos Custom
      </Dropdown.Toggle>

      <Dropdown.Menu className="w-64 max-h-64 overflow-y-auto px-2 py-1.5">
        {fieldsInfo && fieldsInfo.length > 0 ? (
          fieldsInfo.map((item, index) => (
            <Dropdown.Item
              key={index}
              type="button"
              onClick={() => onChange(item.vc_keycolumn)}
              className={classNames(
                "text-gray-800 text-sm py-1.5 px-2 border rounded-lg capitalize transition-colors duration-200 hover:bg-gray-300 my-1",
                {
                  "bg-gray-300": item.vc_keycolumn === value,
                },
              )}
            >
              {item.vc_keycolumn}
            </Dropdown.Item>
          ))
        ) : (
          <div className="text-yellow-800 text-sm font-semibold flex items-center">
            <Icon icon="warning" className="text-yellow-800 px-1" />
            No se han configurado los campos variables.
          </div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

Template.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default Template;
